import Campaigns from './campaignsResource';

import transformCSV from '@/api/shared/transformers/CSVTransformer';

import errorTransformer from '@/api/shared/transformers/errorTransformer';

import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';
import transformCampaignInfo from '@/api/shared/transformers/campaignInfoTransformer';

import parseRange from '@/api/shared/utility/parseRange';

function addCampaign(campaignData) {
  return Campaigns.save({}, campaignData)
    .then(({ body: { message = '' } }) => {
      return message;
    })
    .catch(errorTransformer);
}

function getCampaigns(range = 'last-week') {
  return Campaigns.get(parseRange(range))
    .then(({ body: campaigns }) =>
      campaigns.map(item => transformToCamelCase(item)),
    )
    .catch(errorTransformer);
}

function getCampaignInfo(campaignId) {
  return Campaigns.get({ itemId: campaignId })
    .then(({ body: campaignInfo }) => transformCampaignInfo(campaignInfo))
    .catch(errorTransformer);
}

function updateCampaign({ campaignId, campaignInfo }) {
  return Campaigns.updateCampaign({ itemId: campaignId }, campaignInfo)
    .then(({ body: { message = '' } }) => message)
    .catch(errorTransformer);
}

function deleteCampaign(campaignId) {
  return Campaigns.delete({ itemId: campaignId })
    .then(({ body: { message = '' } }) => message)
    .catch(errorTransformer);
}

function saveCSV(range) {
  return Campaigns.saveCSV(parseRange(range))
    .then(res => transformCSV(res))
    .catch(errorTransformer);
}

function getOverview(range) {
  return Campaigns.getOverview(parseRange(range))
    .then(({ body }) => transformToCamelCase(body))
    .catch(errorTransformer);
}

export default {
  addCampaign,
  getCampaigns,
  updateCampaign,
  getCampaignInfo,
  deleteCampaign,
  saveCSV,
  getOverview,
};
